/* tslint:disable */
/* eslint-disable */
/**
 * Titan API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { WhoIsWorkingModel } from '../models';
// @ts-ignore
import type { WidgetDto } from '../models';
/**
 * WorkingApi - axios parameter creator
 * @export
 */
export const WorkingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingLeavesPost: async (token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Working/Leaves`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whoIsWorkingModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingNoShowsPost: async (token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Working/NoShows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whoIsWorkingModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingPresentsPost: async (token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Working/Presents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whoIsWorkingModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkingApi - functional programming interface
 * @export
 */
export const WorkingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingLeavesPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WidgetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingLeavesPost(token, whoIsWorkingModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingApi.workingLeavesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingNoShowsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WidgetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingNoShowsPost(token, whoIsWorkingModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingApi.workingNoShowsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingPresentsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WidgetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingPresentsPost(token, whoIsWorkingModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingApi.workingPresentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkingApi - factory interface
 * @export
 */
export const WorkingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingLeavesPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: any): AxiosPromise<Array<WidgetDto>> {
            return localVarFp.workingLeavesPost(token, whoIsWorkingModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingNoShowsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: any): AxiosPromise<Array<WidgetDto>> {
            return localVarFp.workingNoShowsPost(token, whoIsWorkingModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingPresentsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: any): AxiosPromise<Array<WidgetDto>> {
            return localVarFp.workingPresentsPost(token, whoIsWorkingModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkingApi - object-oriented interface
 * @export
 * @class WorkingApi
 * @extends {BaseAPI}
 */
export class WorkingApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingApi
     */
    public workingLeavesPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig) {
        return WorkingApiFp(this.configuration).workingLeavesPost(token, whoIsWorkingModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingApi
     */
    public workingNoShowsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig) {
        return WorkingApiFp(this.configuration).workingNoShowsPost(token, whoIsWorkingModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {WhoIsWorkingModel} [whoIsWorkingModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkingApi
     */
    public workingPresentsPost(token?: string, whoIsWorkingModel?: WhoIsWorkingModel, options?: RawAxiosRequestConfig) {
        return WorkingApiFp(this.configuration).workingPresentsPost(token, whoIsWorkingModel, options).then((request) => request(this.axios, this.basePath));
    }
}

